module.exports = __webpack_public_path__ + "static/lightning-datepicker-selected-5bc81730745a8e7ff9b3158536e741c5.png";